export const SLACK_LINK = "https://s.apache.org/dolphinscheduler-slack#general";
export const TWITTER_LINK = "https://twitter.com/dolphinschedule";
export const GITHUB_LINK = "https://github.com/apache/dolphinscheduler";
export const EMAIL = "users@dolphinscheduler.apache.org";
